import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../core/services/environment.service';

@Injectable()
export class ApiBaseUrlInterceptor implements HttpInterceptor {
  private environmentService = inject(EnvironmentService);

  private getApiBaseUrl(): string {
    // Use the full URL from environment for all environments
    // This provides consistency across all environments
    return this.environmentService.apiBaseUrl;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only modify requests that start with /api/, /auth/, or /swagger/
    if (req.url.startsWith('/api/') || req.url.startsWith('/swagger/')) {
      const apiBaseUrl = this.getApiBaseUrl();

      // Only modify the URL if we have a base URL to prepend
      if (apiBaseUrl) {
        const apiUrl = `${apiBaseUrl}${req.url.substring(4)}`; // Remove '/api' and prepend full base URL
        const apiReq = req.clone({ url: apiUrl });

        console.log(`[API Interceptor] ${req.method} ${req.url} → ${apiUrl}`);
        return next.handle(apiReq);
      }
    }

    // For all other requests, pass through unchanged
    return next.handle(req);
  }
}
